import { useLastAppStateStore } from '@app/providers/router/model/store/last-app-state-store'
import { useChannels } from '@entities/channel'
import { AddPostMobileModal, EmptyPost, InfiniteCalendar, MobilePost, usePosts } from '@entities/post'
import { savePayload } from '@entities/post/api'
import { EDisplayPosts } from '@pages/scheduled-posts-page/ui/scheduled-posts-page'
import { dayjs } from '@shared/lib/dayjs/dayjs'
import { randomId } from '@shared/lib/randomId/randomId'
import type { DateInterval } from '@shared/types'
import { BottomNavMobile } from '@widgets/page-template/ui/bottom-nav-mobile'
import { PostingMobileHeader } from '@widgets/posting-mobile-header'
import { Button, theme } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import * as styles from './scheduled-posts-page.mobile.module.scss'

const BOT_USERNAME = process.env.BOT_USERNAME || ''

export const ScheduledPostsPage = () => {
    const {
        token: { colorBgContainer }
    } = theme.useToken()

    const { currentChannel } = useChannels()

    const {
        posts,
        postTypes,
        selectedPostTypes,
        actions: { setSelectedPostTypes, setDates }
    } = usePosts({
        state: 'planned',
        display: EDisplayPosts.period,
        channelId: currentChannel?.id
    })

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

    const onIntervalChange = useCallback((interval: DateInterval) => setDates(interval), [setDates])

    const { sessionId, action, setState, reset } = useLastAppStateStore(
        useShallow(({ sessionId, action, setState, reset }) => ({ sessionId, action, setState, reset }))
    )

    const onCreatePost = () => {
        const tg = (window as any).Telegram?.WebApp

        const sessionId = randomId()

        tg.showConfirm('Для создания поста, необходимо перейти в бот', async (ok?: boolean) => {
            if (!ok) return

            setState({ page: location.pathname, action: 'create-post', sessionId: sessionId })

            const payloadId = await savePayload({
                action: 'create_post',
                session_id: sessionId,
                platform: 'mobile'
            })

            const url = `https://t.me/${BOT_USERNAME}?start=payload_${payloadId}`

            tg.openTelegramLink(url)
            tg.close()
        })
    }

    useEffect(() => {
        if (action === 'create-post') {
            setIsCreateModalOpen(true)
        }
    }, [])

    const onCloseAddPostModal = () => {
        setIsCreateModalOpen(false)
        reset()
    }

    return (
        <>
            <PostingMobileHeader
                title="Запланированные"
                current="scheduled"
                postTypes={postTypes}
                selectedPostTypes={selectedPostTypes}
                setSelectedPostTypes={setSelectedPostTypes}
            />

            <div
                style={{
                    position: 'relative',
                    background: colorBgContainer,
                    padding: '20px 16px 0 16px',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <InfiniteCalendar
                    renderItem={(day) => {
                        const filteredPosts = posts?.results.filter((p) =>
                            p.publishDate ? dayjs(p.publishDate).format('YYYY-MM-DD') === day.date : false
                        )

                        return filteredPosts && filteredPosts.length > 0 ? (
                            <div className={styles.postsSlot}>
                                {filteredPosts.map((p) => (
                                    <MobilePost post={p} key={p.id} />
                                ))}
                            </div>
                        ) : (
                            <EmptyPost title="Постов нет" />
                        )
                    }}
                    onIntervalChange={onIntervalChange}
                />
                <Button size="large" type="primary" className={styles.newPostBtn} onClick={onCreatePost}>
                    Новый пост
                </Button>

                {isCreateModalOpen && sessionId && (
                    <AddPostMobileModal open={isCreateModalOpen} onClose={onCloseAddPostModal} sessionId={sessionId} />
                )}
            </div>
            <BottomNavMobile />
        </>
    )
}
